
export default {
  props: {
    position: {
      // 弹出开始位置
      type: String,
      default: 'bottom'
    },
    getcontainer: {
      // 指定挂载位置
      type: String,
      default: 'body'
    }
  },
  data() {
    return {
      show: false
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) this.$emit('close')
    }
  },
  methods: {
    close() {
      this.show = false
      this.$emit('close')
    },
    open() {
      console.log(2222)
      this.show = true
    },
    getContainer() {
      return document.querySelector(this.getcontainer)
    }
  }
}
